import { ReprtingTemplateList } from './reporting-template-list';

export class ReprtingDetailsDD {
    reporting: Array<ReprtingTemplateList>;

    constructor() {
        this.reporting = [];
    }
}